<template>
  <v-toolbar
    flat
    color="grey lighten-4"
  >
    <v-toolbar-title
      v-if="step === 0"
      class="font-weight-medium"
      v-text="__('cashControl')"
    />
    <v-spacer />
    <v-btn
      v-if="step === 0"
      color="primary"
      icon
      large
      @click="$emit('close')"
    >
      <v-icon v-text="icons.close" />
    </v-btn>
    <span
      v-else
      class="text-h5 font-weight-bold"
    >
      {{ amount | currency }}
      <v-icon
        size="28"
        right
        :color="mode === InOutMode.IN ? 'success' : 'primary'"
        v-text="icons[`cash${mode}`]"
      />
    </span>
  </v-toolbar>
</template>

<script>
  import { mapState } from 'vuex'
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import InOutMode from '@/Models/Static/InOutMode'

  export default {
    mixins: [
      Currenciable,
      I18n,
      UsesIcons,
    ],

    props: {
      amount: {
        required: true,
        type: Number,
      },
    },

    data: () => ({
      InOutMode,
    }),

    computed: {
      ...mapState('inOut', [
        'step',
        'mode',
      ]),
    },
  }
</script>
